import * as XLSX from "xlsx";
import dayjs from "dayjs";

import type { ProductionBatchSummary } from "~/types/production";
import { PRODUCTION_BATCH_STATUS_LABELS } from "~/types/production";
import { getProductionUnitLabel } from "~/constants/units";

export function exportProductionBatchesToExcel(
  batches: ProductionBatchSummary[]
): void {
  const exportData = batches.map((batch) => ({
    "N° Lote": batch.batch_number,
    Producto: batch.product_name,
    SKU: batch.product_sku || "-",
    Línea: batch.assembly_line || "-",
    Planta: batch.plant || "-",
    "Cantidad Objetivo": batch.target_quantity,
    "Cantidad Real": batch.actual_quantity ?? "-",
    Unidad: getProductionUnitLabel(batch.production_unit, 1),
    "Fecha Inicio": dayjs(batch.start_date).format("DD/MM/YYYY"),
    "Fecha Fin": dayjs(batch.end_date).format("DD/MM/YYYY"),
    "Fecha Vencimiento": dayjs(batch.expiry_date).format("DD/MM/YYYY"),
    "Costo Estimado (CLP)": batch.estimated_cost_clp ?? "-",
    "Costo Real (CLP)": batch.actual_cost_clp ?? "-",
    "Costo por Unidad (CLP)": batch.cost_per_box_clp ?? "-",
    "Costo Estimado (USD)": batch.estimated_cost_usd ?? "-",
    "Costo Real (USD)": batch.actual_cost_usd ?? "-",
    "Contiene Alérgenos": batch.contains_allergens ? "Sí" : "No",
    Estado: PRODUCTION_BATCH_STATUS_LABELS[batch.status],
    "Creado Por": batch.created_by_name || "-",
    "Fecha Creación": dayjs(batch.created_at).format("DD/MM/YYYY HH:mm"),
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  ws["!cols"] = [
    { wch: 18 }, // N° Lote
    { wch: 30 }, // Producto
    { wch: 12 }, // SKU
    { wch: 10 }, // Línea
    { wch: 10 }, // Planta
    { wch: 15 }, // Cantidad Objetivo
    { wch: 12 }, // Cantidad Real
    { wch: 10 }, // Unidad
    { wch: 12 }, // Fecha Inicio
    { wch: 12 }, // Fecha Fin
    { wch: 15 }, // Fecha Vencimiento
    { wch: 18 }, // Costo Estimado CLP
    { wch: 15 }, // Costo Real CLP
    { wch: 18 }, // Costo por Unidad
    { wch: 18 }, // Costo Estimado USD
    { wch: 15 }, // Costo Real USD
    { wch: 15 }, // Alérgenos
    { wch: 12 }, // Estado
    { wch: 20 }, // Creado Por
    { wch: 18 }, // Fecha Creación
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Lotes de Producción");

  const filename = `lotes_produccion_${dayjs().format("YYYY-MM-DD")}.xlsx`;
  XLSX.writeFile(wb, filename);
}
